import { render, staticRenderFns } from "./AssignCourseOperations.vue?vue&type=template&id=64024e86"
import script from "./AssignCourseOperations.vue?vue&type=script&lang=ts"
export * from "./AssignCourseOperations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports